"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.settings.general': '常规',
    'route.settings.styles': '样式',
    'route.settings.access': '访问',
    'route.settings.accessEdit': '编辑访问',
    'route.settings.accessAdd': '添加访问',
    'route.settings.socialMediaPlan': '品牌与团队',
    'route.settings.whatsapp': 'WhatsApp',
    'route.settings.whatsapp.manage': '管理WhatsApp号码',
    'route.settings.whatsappSettings': 'WhatsApp号码',
    'route.settings.whatsappSettings.create': '添加WhatsApp号码',
    'route.settings.whatsappSettings.edit': '编辑WhatsApp号码',
};
